import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaB_Van_Center: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="168"
      height="398"
      viewBox="0 0 168 398"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_van_center"
          x="0"
          y="0"
          width="168"
          height="398"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_b_van_center)">
        <path
          d="M9.30176 201.644C9.20925 196.759 9.12057 191.585 9.03613 185.908L8.95312 180.057L8.84668 171.651C7.79652 80.4169 2.9034 25.2084 1.09668 8.05664C3.33254 7.77862 6.65084 7.27166 10.333 6.72363C15.6824 5.92747 22.258 4.97414 28.8184 4.23535L29.1855 4.19336C54.8325 1.34329 77.8712 0.835071 94.5215 1.04102C102.883 1.14444 109.624 1.42761 114.263 1.68457C116.582 1.81305 118.376 1.93443 119.583 2.02344C120.186 2.06791 120.643 2.104 120.945 2.12891C121.095 2.14125 121.205 2.15143 121.283 2.1582C121.292 2.15892 121.3 2.15867 121.307 2.15918C121.336 2.16306 121.373 2.16875 121.418 2.1748C121.469 2.18158 121.529 2.1894 121.597 2.19824C121.863 2.23282 122.255 2.28394 122.76 2.34961C123.768 2.48086 125.225 2.67044 127.015 2.9043C130.596 3.37213 135.513 4.01622 140.857 4.72266C149.378 5.84908 158.962 7.13204 165.95 8.10645C164.139 25.3152 159.256 80.5052 158.207 171.651C158.069 183.356 157.916 192.956 157.752 201.637L157.751 201.675V250.067C157.138 282.375 156.418 302.452 156.048 372.882L155.907 374.311L155.902 374.357V374.404L155.832 390.867L155.821 392.232C155.615 392.27 155.365 392.314 155.068 392.363C154.272 392.495 153.221 392.653 151.931 392.829L150.562 393.012C146.708 393.513 141.295 394.12 134.727 394.706C121.587 395.879 103.903 396.965 84.9131 396.965H81.8496C62.8693 396.965 45.1895 395.879 32.0508 394.706C25.483 394.12 20.069 393.513 16.2139 393.012C14.2832 392.761 12.767 392.539 11.7041 392.363C11.4979 392.329 11.314 392.296 11.1514 392.268V374.371L11.1475 374.324L11.1289 374.127L11.1279 374.121L11.0029 372.88C10.7599 326.641 10.3678 302.106 9.95312 281.563L9.53613 261.688L9.30176 249.999V201.644Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
